import { Product } from "@core/types";
import { useCallback } from "react";
import { useProductDetailSheetStore } from "../providers/productDetailSheetStore";

type OpenProductDetailSheetProps = {
  id: Product["id"];
  productType?: Product["type"];
};

const useOpenProductDetailSheet = () => {
  const open = useProductDetailSheetStore((state) => state.open);

  return useCallback(
    ({ id, productType }: OpenProductDetailSheetProps) => {
      open(id, productType);
    },
    [open],
  );
};

export default useOpenProductDetailSheet;